module.exports = __webpack_public_path__ + "img/33.70119033.png";